import React, { useState } from 'react';
import { gql, useApolloClient } from '@apollo/client';
import TaskButton from '$components/Admin/TaskButton';

const UnlockCourse = (props) => {
  const { productSlug, userUuid } = props;

  const client = useApolloClient();
  const [task, setTask] = useState(null);

  const UNLOCK_COURSE_MUTATION = gql`
    mutation UnlockCourse($input: UnlockCourseInput!) {
      unlockCourse(input: $input) {
        task {
          uuid
          status
          type
        }
      }
    }
  `;

  const unlockCourse = async () => {
    const { data } = await client.mutate({
      mutation: UNLOCK_COURSE_MUTATION,
      variables: {
        input: {
          userUuid,
          productSlug,
        },
      },
    });

    const {
      unlockCourse: { task },
    } = data;
    setTask(task);
  };

  return (
    <TaskButton
      task={task}
      productSlug={productSlug}
      buttonText="Unlock Course"
      onClick={unlockCourse}
    />
  );
};

export default UnlockCourse;
